// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"609":"5a78c7f8","657":"cce8131f","812":"5a8968a5","887":"65612f96"}[chunkId] + ".chunk.css";
};